import onLoad from '../../../javascripts/utils/onLoad';

const setLoaded = ($image: HTMLImageElement) => {
  if (!$image.complete || $image.naturalHeight === 0) {
    return;
  }

  const $container = $image.closest<HTMLElement>('.image');

  if ($container) {
    $image.addEventListener(
      'transitionend',
      () => {
        $container.style.backgroundImage = '';
      },
      { once: true },
    );

    $container.setAttribute('data-image-loaded', 'data-image-loaded');
  }
};

onLoad<HTMLImageElement>('.image__img', setLoaded);

document.addEventListener(
  'load',
  ({ target: $image }) => {
    if ($image instanceof HTMLImageElement && $image.matches('.image__img')) {
      setLoaded($image);
    }
  },
  { capture: true },
);
